import React, { useEffect, useState } from 'react';
import configData from '../../../temp/config';
import { withTranslation } from 'react-i18next';
import './Genderdropdown.css';

// import CustomDropDown from '../drop-down-component/CustomDropDown';

const Genderdropdown = (props) => {
    const [showItems, setShowItems] = useState(false)
    const [defaultSearchType, setDefaultSearchType] = useState(props.defaultSelectedGender);
    const [genderImage, setGenderImage] = useState('')
    const { t } = props;

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        if (props.defaultSelectedGender !== 'Select Gender') {
            let image = props.componentData.genders.filter((item, index) => {
                if (props.defaultSelectedGender.toLowerCase() === item.fields.name.value.toLowerCase()) {
                    return item
                }
            })
            if (image.length > 0) {
                setGenderImage(image[0].fields)
            }
        }
        // props.getSearchType(props.searchTypes[0].fields)
        // setDefaultSearchType(props.defaultSelectedGender === '' ? 'Select Gender' : props.defaultSelectedGender)
    }, [])

    const handleClickOutside = (event) => {
    //    console.log(event.target.className)
        if (event.target.className === 'slect-box-selected-item-text-div-close' || event.target.className === 'slect-box-selected-item-text-faded' ||
            event.target.className === 'select-box--arrow-up fa fa-angle-up') {
            setShowItems(true)
        }
        // if (event.target.className === 'select-box--selected-item' && document.getElementsByClassName('select-box--arrow-down')[0] !== undefined) {
        //     setShowItems(true)
        // }
        else if (event.target.className === 'select-box--arrow-down') {
            setShowItems(false)
        }
        else if (event.target.className === 'select-box--arrow-up') {
            setShowItems(true)
        } else {
            setShowItems(false)
        }
        // if(event.target.className === 'select-box--selected-item opened') setShowItems(true)

    }

    const dropDown = () => {
        showItems ? setShowItems(false) : setShowItems(true)
    }

    const closeDropDown = () => {
        setShowItems(false)
    }

    const selectItem = (item) => {
        setGenderImage(item.fields)
        setDefaultSearchType(item.fields.name.value)
        setShowItems(false)
        props.detectGender(item.fields.name.value)
    }

    return (
        <div className="nameSearchFieldDropdown">
            <div className="custom-select-dropdown">

                <div className="select-box--box">
                    <div className="select-box--container"  >
                        <div className={"select-box--selected-item"} onClick={dropDown}>
                            <div className={!showItems ? "slect-box-selected-item-text-div" : 'slect-box-selected-item-text-div-close'} >
                                {genderImage.logo && <img className="gender-img" src={configData.sitecoreApiHost + genderImage.logo.value.src} />}
                                <span style={{ 'textTransform': 'capitalize' }} className={defaultSearchType === 'Select Gender' ? "slect-box-selected-item-text-faded" : "slect-box-selected-item-text"}>{defaultSearchType.toLowerCase()}</span>
                            </div>
                            <div className="select-box--arrow" name="select-box--name">
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div>
                        </div>
                        {/* <div className="select-box--arrow" name="select-box--name" onBlur={closeDropDown}>
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div> */}
                        <div style={{ display: showItems ? 'block' : 'none' }}
                            className="select-box--items gender-month-wrapper"
                        >

                            {
                                props.componentData.genders.map((item, index) => {
                                    return (
                                        <div className="gender-select-div" key={index} onClick={() => selectItem(item)}>
                                            <img className="gender-img" src={configData.sitecoreApiHost + item.fields.logo.value.src} />
                                            <p className="nameListItem"> {item.fields.name.value} </p>
                                        </div>
                                    )
                                })
                            }



                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}



export default withTranslation()(Genderdropdown);